/**
 *  Created by artem.elyseev@racingpost.com
 *
 *  Index component
 *  Navigation structure
 */

/**
 * Import third-party modules
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const App = ({ children }) => {
    const linkClasses = {
        className: 'ui-tabs__tab ui-tabs__link ui-link',
        activeClassName: 'ui-tabs__tab_selected'
    };

    return (
        <div>
            <h1 className="tn-header">
                Tips Tables
            </h1>
            <div className="ui-tabs">
                <nav className="ui-tabs tn-tabs">
                    <Link
                        {...linkClasses}
                        to="/naps-table/"
                    >
                        Naps Table
                    </Link>
                    <Link
                        {...linkClasses}
                        to="/press-challenge/"
                    >
                        Press Challenge
                    </Link>
                </nav>
            </div>
            {children}
        </div>
    );
};
/**
 * Prop types validation
 * Expected NapsTable and PressChallenge tables as child nodes
 * @type {{children: *}}
 */
App.propTypes = {
    children: PropTypes.node
};

export default App;



// WEBPACK FOOTER //
// ./src/js/App.js